import { Component, Input, Host, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { SelectOption } from '../../../common';
import { RadioGroup2Component } from '../radio-group2/radio-group2.component';

@Component({
    selector: 'aa-radio2',
    templateUrl: './radio2.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class Radio2Component implements OnInit
{
    @Input() name: string;
    @Input() option: SelectOption;
    @Input() toTranslate: boolean = false;
    public optionId: string;

    constructor (@Host() private radioGroup: RadioGroup2Component)
    { }

    ngOnInit ()
    {
        this.optionId = `id-${this.option.label}-${this.option.value}`;
    }

    toggle ()
    {
        this.radioGroup.toggle(this.option.value);
    }

    isChecked ()
    {
        return this.radioGroup.value === this.option.value;
    }
}
